import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const StaffParking = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        label="Staff Parking"
        value={opsPlan?.staffParking}
        suggestionPath="opsPlan.staffParking"
        suggestionLabel="Staff parking notes from templates"
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            staffParking: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!opsPlan?.staffParking,
        }}
        fullWidth
        multiline
        minRows={2}
        autoComplete="off"
        name="opsplan-staffparking"
      />
    </Grid>
  )
}

export default React.memo(StaffParking)
